/**
 * Domain enum for the offsite briefing channel. No sentinel value: absence
 * means "legacy flow" and is represented by the key being omitted from
 * `settings`, not by a value here. See spec.md — "Por que não existe um
 * canal LEGACY".
 */
export enum CampaignChannel {
  DV360 = 'dv360',
  META = 'meta'
}

/**
 * Presentation-layer view: adds the `'legacy'` sentinel that the domain
 * deliberately does not have. Convert at the single entry point into a
 * visualization component — never inside domain/DTO code.
 */
export type ChannelView = CampaignChannel | 'legacy'

export const toChannelView = (channel?: CampaignChannel): ChannelView =>
  channel ?? 'legacy'

export const isCampaignChannel = (value: string): value is CampaignChannel =>
  (Object.values(CampaignChannel) as string[]).includes(value)

declare global {
  /**
   * Mirror of CampaignChannel's values for ambient types.d.ts files, which
   * can't import (they'd scope the whole file to a module). Keeps the raw
   * backend shape ('dv360' | 'meta') in one place instead of retyping it
   * wherever a DTO needs it.
   */
  type CampaignChannelValue = `${CampaignChannel}`
}
